import { Action2 } from '../Models/Common/Delegates';

export class Events {
    public static readonly OnUrlStateChanged: Action2<string, string | undefined> = new Action2<string, string | undefined>();
}